import { ZuoraSubscriptionNextInvoice } from './ZuoraSubscriptionNextInvoice';
import { LegacySubscriptionNextInvoice } from './LegacySubscriptionNextInvoice';

export interface SubscriptionNextInvoiceProps {
  subscriptionInfo: SubscriptionInfo;
  zuoraEnabled?: boolean;
  hasPaidPlan: boolean;
}

export interface SubscriptionInfo {
  prices: Price;
  paymentMethod: PaymentInfo;
  nextBillingDate: number;
  hasPaidPlan?: boolean;
  alerts: Alerts;
}

interface PaymentInfo {
  label?: string;
  expiryDate: number;
  type: string;
  available: boolean;
}

interface Alerts {
  trialEndingSoon: boolean;
  recurringPaymentFailed: boolean;
}

interface Price {
  currency?: string | null;
  symbol?: string | null;
  subtotal: number | null;
  vatRate: number | null;
  vatTotal: number | null;
  total: number;
}

export const SubscriptionNextInvoice = ({
  subscriptionInfo,
  hasPaidPlan,
  zuoraEnabled,
}: SubscriptionNextInvoiceProps): JSX.Element =>
  zuoraEnabled ? (
    <ZuoraSubscriptionNextInvoice subscriptionInfo={subscriptionInfo} hasPaidPlan={hasPaidPlan} />
  ) : (
    <LegacySubscriptionNextInvoice subscriptionInfo={subscriptionInfo} hasPaidPlan={hasPaidPlan} />
  );

// eslint-disable-next-line import/no-default-export
export default SubscriptionNextInvoice;
